import { CrudTable, StatusBadge } from "@/components/shared";
import { inr } from "@/lib/api";

const SERVICES = ["Rhinoplasty", "Hair Transplant", "Liposuction", "Botox", "Dermal Fillers", "Laser Skin", "Facelift", "Gynecomastia"];

export default function Upsells() {
  const columns = [
    { key: "date", label: "Date", render: (r) => r.date?.slice(0, 10) },
    { key: "patient_name", label: "Patient" },
    { key: "branch", label: "Branch" },
    { key: "deal_type", label: "Type", render: (r) => <StatusBadge value={r.deal_type} /> },
    { key: "primary_service", label: "Primary Service" },
    { key: "offered_service", label: "Offered" },
    { key: "offered_by", label: "Offered By" },
    { key: "status", label: "Status", render: (r) => <StatusBadge value={r.status} /> },
    { key: "value", label: "Value", render: (r) => <span className="font-mono-ync">{inr(r.value)}</span> },
  ];
  const fields = [
    { key: "patient_id", label: "Patient (linked)", type: "patient", full: true },
    { key: "patient_name", label: "Patient Name (or type manually)", type: "text" },
    { key: "branch", label: "Branch", type: "select", optionsKey: "branches" },
    { key: "deal_type", label: "Deal Type", type: "select", options: ["Upsell", "Cross-sell"] },
    { key: "primary_service", label: "Primary Service", type: "select", options: SERVICES },
    { key: "offered_service", label: "Offered Service", type: "select", options: SERVICES },
    { key: "offered_by", label: "Offered By", type: "select", options: ["Reception", "Counselor", "Doctor", "Relationship Manager"] },
    { key: "status", label: "Status", type: "select", options: ["Offered", "Accepted", "Declined", "Pending"] },
    { key: "value", label: "Deal Value (₹)", type: "number" },
    { key: "notes", label: "Notes", type: "textarea", full: true },
  ];
  return (
    <CrudTable
      testid="upsells" endpoint="upsells" dateField="date"
      title="Upsell & Cross-Sell"
      subtitle="Track every additional service offered, who offered it, and whether the patient accepted — grow revenue per patient."
      columns={columns} fields={fields}
      defaults={{ deal_type: "Upsell", status: "Offered", value: 0 }}
    />
  );
}
